import { useCardNumberAndCvv, useStoreCardView } from "@usher/pe-client-front-end-lib"
import { Eye, EyeOff } from "lucide-react"
import { FormattedMessage } from "react-intl"
import { DetailItem } from "./DetailItem"

export const CardDetailsSensitive = () => {
  const { type, expiryDate } = useStoreCardView((state) => state.card)
  const { cardCvv, cardNumber, cvvToggled, panToggled, cardClosed, toggleCvv, togglePan } = useCardNumberAndCvv()

  return (
    <div className="block-one-card_details">
      <div className="block-one-card_info-title text-[14px]">
        <FormattedMessage id="sensitive" />
      </div>
      <DetailItem label="card-number">
        <div className="flex items-center gap-1 text-sm">
          {cardNumber}
          {!cardClosed && (
            <div className="button-view-details" onClick={() => togglePan()}>
              {panToggled ? <EyeOff size={16} /> : <Eye size={16} />}
            </div>
          )}
        </div>
      </DetailItem>
      {type !== "3" && (
        <DetailItem label="CVV">
          <div className="flex items-center gap-1 text-sm">
            {cardCvv}
            {!cardClosed && (
              <div className="button-view-details" onClick={() => toggleCvv()}>
                {cvvToggled ? <EyeOff size={16} /> : <Eye size={16} />}
              </div>
            )}
          </div>
        </DetailItem>
      )}
      <DetailItem label="expr-date">
        <span className="text-sm">{expiryDate || "N/A"}</span>
      </DetailItem>
    </div>
  )
}
